import * as React from 'react'

function FemaleIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={93.876} height={59.417} viewBox="0 0 93.876 59.417" {...props}>
      <g
        data-name="Group 108"
        transform="translate(-333.474 -550.733)"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          data-name="Line 207"
          transform="translate(333.974 609.65)"
          stroke="#1a1818"
          strokeWidth={1}
          d="M0 0L92.876 0"
        />
        <path
          data-name="Path 767"
          d="M392.98 572.892s-2.558 18.81-12.563 18.81c-8.181 0-11.383-12.576-12.277-17.163"
          stroke="#1a1818"
          strokeWidth={1}
        />
        <path
          data-name="Path 768"
          d="M387.2 588.763v4.059c0 2.554.924 3.45 3.891 3.45h5.686a6.1 6.1 0 015.92 5.122l.931 4.713"
          stroke="#1a1818"
          strokeWidth={1}
        />
        <path
          data-name="Path 769"
          d="M373.621 588.763v4.059c0 2.554-.924 3.45-3.891 3.45h-5.686a6.1 6.1 0 00-5.92 5.122l-.931 4.713"
          stroke="#1a1818"
          strokeWidth={1}
        />
        <path data-name="Path 770" d="M390.852 596.4a12.386 12.386 0 01-20.951-.132" stroke="#1a1818" strokeWidth={1} />
        <path
          data-name="Path 771"
          d="M363.2 596.355v-29.841c0-14.35 19.286-20.649 26-9.74 2.626-2.171 7.695-.166 7.957 8.119s0 31.379 0 31.379"
          stroke="#1a1818"
          strokeWidth={1}
        />
        <path
          data-name="Path 772"
          d="M366.442 575.454c.055-2.086.6-5.489 5.818-6.258s11.472-.549 13.064-5.324"
          stroke="#1a1818"
          strokeWidth={1}
        />
        <path
          data-name="Path 773"
          d="M384.8 560.756c-1.04 6.167 10.15 7.577 9.678 12.95"
          stroke="#1a1818"
          strokeWidth={1.003}
        />
        <path
          data-name="Path 774"
          d="M377.482 584.218a1.035 1.035 0 001.045.6h4.064a1.035 1.035 0 001.046-.6"
          stroke="#ea3e3b"
          strokeWidth={1}
        />
        <path data-name="Path 775" d="M379.436 586.536a2.07 2.07 0 002.247 0" stroke="#ea3e3b" strokeWidth={1} />
        <path data-name="Path 776" d="M378.96 579.875a2.136 2.136 0 003.2 0" stroke="#1a1818" strokeWidth={1.001} />
        <path
          data-name="Path 777"
          d="M372.244 574.41a3.153 3.153 0 012.081-.749 3.075 3.075 0 012.31.979"
          stroke="#1a1818"
          strokeWidth={0.998}
        />
        <path
          data-name="Path 778"
          d="M374.325 573.661a.819.819 0 11-.819.819.819.819 0 01.819-.819z"
          stroke="#1a1818"
          strokeWidth={1}
        />
        <path
          data-name="Path 779"
          d="M388.876 574.41a3.155 3.155 0 00-2.081-.749 3.076 3.076 0 00-2.311.979"
          stroke="#1a1818"
          strokeWidth={0.998}
        />
        <path
          data-name="Path 780"
          d="M386.794 573.661a.819.819 0 10.819.819.819.819 0 00-.819-.819z"
          stroke="#1a1818"
          strokeWidth={1}
        />
        <path data-name="Path 781" d="M371.519 572.235a16.881 16.881 0 015.8-.664" stroke="#1a1818" strokeWidth={1} />
        <path data-name="Path 782" d="M389.6 572.235a16.881 16.881 0 00-5.8-.664" stroke="#1a1818" strokeWidth={1} />
      </g>
    </svg>
  )
}

export default FemaleIcon
